import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './arrow.svg'


_pushScopeId("data-v-37809df5")
const _hoisted_1 = { class: "sunrise-title py-10" }
const _hoisted_2 = { class: "flex-column" }
const _hoisted_3 = { class: "sunrise-title-text uppercase" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "sunrise-subtitle-text" }, "Bond", -1)
const _hoisted_5 = { class: "bond-title" }
const _hoisted_6 = { class: "flex-column" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "token-name mt-[8px] uppercase" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_10 = { class: "flex-column" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "token-name mt-[8px] uppercase" }
const _hoisted_13 = { class: "details mt-[32px]" }
const _hoisted_14 = {
  key: 0,
  class: "mt-[24px] flex justify-center gap-[12px]"
}
const _hoisted_15 = {
  key: 1,
  class: "mt-[24px] flex justify-center gap-[12px]"
}
const _hoisted_16 = { class: "bond-h1" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "bond-h2" }, "Last-Hour TWAP Price", -1)
const _hoisted_18 = { class: "bond-h1" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "bond-h2" }, "Previous Epoch TWAP Price", -1)
const _hoisted_20 = { class: "bond-h1" }
const _hoisted_21 = { class: "bond-h2" }
const _hoisted_22 = { class: "bond-title" }
const _hoisted_23 = { class: "flex-column" }
const _hoisted_24 = ["src"]
const _hoisted_25 = { class: "token-name mt-[8px] uppercase" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_27 = { class: "flex-column" }
const _hoisted_28 = ["src"]
const _hoisted_29 = { class: "token-name mt-[8px] uppercase" }
const _hoisted_30 = { class: "details mt-[32px]" }
const _hoisted_31 = { class: "mt-[24px] flex justify-center" }
const _hoisted_32 = {
  key: 1,
  class: "claim-btn"
}
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" Enabled when ")
const _hoisted_34 = { class: "uppercase" }
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" > 1.01 ")
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BondModal = _resolveComponent("BondModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.sunrise.name), 1),
        _hoisted_4
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass({ info: _ctx.isDesktop, infoMobile: _ctx.isMobile })
    }, " Buy & Redeem Bonds. Earn premiums upon redemption ", 2),
    _createElementVNode("div", {
      class: _normalizeClass([{ sunrise: _ctx.isDesktop, sunriseMobile: _ctx.isMobile }, "justify-center text-center"])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass({ card: _ctx.isDesktop, cardMobile: _ctx.isMobile })
      }, [
        _createElementVNode("div", _hoisted_5, "Purchase " + _toDisplayString(_ctx.sunrise.bond), 1),
        _createElementVNode("div", {
          class: _normalizeClass(["mt-[40px] flex items-center justify-between", { tokenTransition: _ctx.isDesktop, tokenTransitionMobile: _ctx.isMobile }])
        }, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("img", {
              src: _ctx.logo[_ctx.sunrise.name]
            }, null, 8, _hoisted_7),
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.sunrise.name), 1)
          ]),
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("img", {
              src: _ctx.bondLogo[_ctx.sunrise.name]
            }, null, 8, _hoisted_11),
            _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.sunrise.bond), 1)
          ])
        ], 2),
        _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.sunrise.bond) + " is available for purchase ", 1),
        (_ctx.approved)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("button", {
                class: "purchase-button",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.togglePurchaseBondModal && _ctx.togglePurchaseBondModal(...args)))
              }, " Purchase ")
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("button", {
                class: "purchase-button",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.approve && _ctx.approve(...args)))
              }, "Approve")
            ])),
        _createVNode(_component_BondModal, {
          purchaseBol: true,
          isVisible: _ctx.isPurchaseBondModalVisible,
          balance: _ctx.tokenBalance,
          name: _ctx.sunrise.bond,
          account: _ctx.account,
          sunriseName: _ctx.sunrise.name,
          onClose: _ctx.togglePurchaseBondModal,
          onUpdate: _ctx.render
        }, null, 8, ["isVisible", "balance", "name", "account", "sunriseName", "onClose", "onUpdate"])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass({ data: _ctx.isDesktop, dataMobile: _ctx.isMobile })
      }, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.sunrise.name.toUpperCase()) + " = " + _toDisplayString(_ctx.currentTwap) + " " + _toDisplayString(_ctx.sunrise.lpToken), 1),
          _hoisted_17
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.sunrise.name.toUpperCase()) + " = " + _toDisplayString(_ctx.previousEpochTwap) + " " + _toDisplayString(_ctx.sunrise.lpToken), 1),
          _hoisted_19
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.sunrise.bond) + " = " + _toDisplayString(_ctx.bondPrice) + " " + _toDisplayString(_ctx.sunrise.lpToken), 1),
          _createElementVNode("div", _hoisted_21, " Current Price: (" + _toDisplayString(_ctx.sunrise.name.toUpperCase()) + ")^2 ", 1)
        ])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass({ card: _ctx.isDesktop, cardMobile: _ctx.isMobile })
      }, [
        _createElementVNode("div", _hoisted_22, "Redeem " + _toDisplayString(_ctx.sunrise.lpToken.toUpperCase()), 1),
        _createElementVNode("div", {
          class: _normalizeClass(["mt-[40px] flex items-center justify-between px-[70px]", { tokenTransition: _ctx.isDesktop, tokenTransitionMobile: _ctx.isMobile }])
        }, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("img", {
              src: _ctx.bondLogo[_ctx.sunrise.name]
            }, null, 8, _hoisted_24),
            _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.sunrise.bond), 1)
          ]),
          _hoisted_26,
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("img", {
              src: _ctx.logo[_ctx.sunrise.name]
            }, null, 8, _hoisted_28),
            _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.sunrise.name), 1)
          ])
        ], 2),
        _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.bondBalance) + " " + _toDisplayString(_ctx.sunrise.bond) + " Redeemable ", 1),
        _createElementVNode("div", _hoisted_31, [
          (_ctx.redeemEnabled)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "purchase-button",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleRedeemBondModal && _ctx.toggleRedeemBondModal(...args)))
              }, " Redeem "))
            : (_openBlock(), _createElementBlock("button", _hoisted_32, [
                _hoisted_33,
                _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.sunrise.name), 1),
                _hoisted_35
              ]))
        ]),
        _createVNode(_component_BondModal, {
          purchaseBol: false,
          isVisible: _ctx.isRedeemBondModalVisible,
          balance: _ctx.bondBalance,
          name: _ctx.sunrise.bond,
          account: _ctx.account,
          sunriseName: _ctx.sunrise.name,
          onClose: _ctx.toggleRedeemBondModal,
          onUpdate: _ctx.render
        }, null, 8, ["isVisible", "balance", "name", "account", "sunriseName", "onClose", "onUpdate"])
      ], 2)
    ], 2)
  ], 64))
}